import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/crispy bites/salted.png";
import BiscuitImg from "../../../assets/products/crispy bites/Salt-Biscuits.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 22,
  },
];

export default function SaltProduct() {
  return (
    <>
      <Helmet>
        <title>
          Crispy Salt Biscuits – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Crispy Salt Biscuits — lightly salted, crisp and ideal for snacking. View pack sizes and specifications."
        />
        <meta
          name="keywords"
          content="Crispy Salt Biscuits, BearBitz Salt Biscuits"
        />
        <link rel="canonical" href="https://www.bearbitz.in/crispy-biscuit/salt" />
        <meta property="og:title" content="Crispy Salt Biscuits – BearBitz" />
        <meta
          property="og:description"
          content="Lightly salted crisp biscuits by BearBitz, made to export standards."
        />
      </Helmet>

      <ProductTemplate
        productTitle="SALT CRACKERS"
        productImage={BisImg}
        description="Savor the simple joy of Salt Biscuits, baked to a golden crisp with just the right touch of salt. Light, crunchy, and perfectly balanced, they make an ideal companion for tea, coffee."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#F04834"
        sectionBgColor="#FFACA2"
        productBgcolor="#FFE5E2"
        tableheadBgcolor="#F04834"
        tableBgcolor="#FFF4EE"
        footerBgcolor="#F04834"
      />
    </>
  );
}
